<footer class="footer_public">
  <span>{{'LOGIN.FOOTER.COPYRIGHT' | translate}} | {{'LOGIN.FOOTER.DEVELOPMENT' | translate}}
    <span class="tsp-company-label">
      {{'LOGIN.FOOTER.COMPANY_ACRONYM' | translate}}</span>
  </span>
</footer>